import React, { useEffect, useState } from "react";
import { ref, get } from "firebase/database";
import { database } from "../../firebase";
import TopBar from "../Sidebar/SidebarUser";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Alert,
  Paper,
} from "@mui/material";

const Notif = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch notifications from Firebase
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const snapshot = await get(ref(database, "notifications"));
        if (snapshot.exists()) {
          // Assuming notifications stored as an object, convert to array and sort by timestamp desc
          const data = snapshot.val();
          const notifArray = Object.values(data).sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          );
          setNotifications(notifArray);
        } else {
          setNotifications([]);
        }
      } catch (err) {
        setError("Failed to load notifications.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f7f9fc", pt: 8 }}>
      <TopBar />
      <Box
        sx={{
          maxWidth: 600,
          mx: "auto",
          p: 3,
        }}
      >
        <Typography
          variant="h4"
          align="left"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#3b99a1",
          }}
        >
          Notifications
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : notifications.length === 0 ? (
          <Typography align="center" color="text.secondary" sx={{ mt: 4 }}>
            No notifications found.
          </Typography>
        ) : (
          <Paper>
            <List>
              {notifications.map((notif, index) => (
                <ListItem key={index} divider>
                  <ListItemText
                    primary={notif.title || "Notification"}
                    secondary={notif.message || ""}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </Box>
    </Box>
  );
};

export default Notif;
